class BulkChangeReq{
    constructor(){
        this.ids = [];
        this.id = null;
    }
}

export default BulkChangeReq;